import { render, staticRenderFns } from "./LoginRecuperarSenhaEmail.vue?vue&type=template&id=1d5e7ec4&"
import script from "./LoginRecuperarSenhaEmail.vue?vue&type=script&lang=js&"
export * from "./LoginRecuperarSenhaEmail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports